import React, { Component } from 'react';
import { find, get } from 'lodash';
import { MODELS } from '../../../constants/admin/settings';
import PerformancesModal from './PerformancesModal';
import PerformancesSetlistModal from './PerformancesSetlistModal';
import Button from '../../forms/Button';
import { UserContext } from '../../../Application';
import { accessToClearance } from '../../../selectors/authentication';
import CategoryBadge from '../../CategoryBadge';
import { applyDefaultLabelsToClearing } from '../../../lib/clearance.utils';
import Tooltip from '../../forms/Tooltip';
import { isUnlimited } from '../../../lib/date.utils';

class PerformancesStates extends Component {
    state = {
        editModalOpen: false,
        setlistModalOpen: false
    };

    _getPartnerName = clearing => {
        const partners = this.props.dependencies.partners || [];
        return (
            get(
                find(partners, p => p.id === clearing.partnerId),
                'name'
            ) || ''
        );
    };

    _closeModal = () => {
        this.setState({ editModalOpen: false });
    };

    _saveModal = (partnerId, data) => {
        const categories = this.props.categoryConfig?.categories || [];
        const copyForByCategory = data.copyForByCategory || {};
        let newClearing = [...(this.props.clearing || [])].map(c => {
            const isOriginalPartner = c.partnerId === partnerId;
            const isDuplicateTarget = categories.some(category =>
                (copyForByCategory[category.id] || []).includes(c.partnerId)
            );

            if (isOriginalPartner) {
                const updatedClearing = { partnerId: c.partnerId, comment: data.comment || '' };
                categories.forEach(category => {
                    if (data[category.id] !== undefined) {
                        updatedClearing[category.id] = data[category.id];
                    }
                });
                return updatedClearing;
            } else if (isDuplicateTarget) {
                const updatedClearing = { ...c };
                categories.forEach(category => {
                    const isVisibleForTarget = this._isCategoryVisible(category, c.partnerId);
                    const shouldCopy = (copyForByCategory[category.id] || []).includes(c.partnerId);
                    if (isVisibleForTarget && shouldCopy) {
                        updatedClearing[category.id] = data[category.id];
                    }
                });
                updatedClearing.comment = data.comment || '';
                return updatedClearing;
            } else {
                return c;
            }
        });

        if (this.props.categoryConfig) {
            newClearing = applyDefaultLabelsToClearing(newClearing, this.props.categoryConfig);
        }

        this.props.setClearing(newClearing, `${MODELS.ENTRY}.clearing`);
        this.setState({ editModalOpen: false });
    };

    _openModal = partner => {
        this.setState({ editModalOpen: partner });
    };

    _openSetlistModal = () => {
        this.setState({ setlistModalOpen: true });
    };

    _closeSetlistModal = () => {
        this.setState({ setlistModalOpen: false });
    };

    _saveSetlistModal = setlist => {
        this.props.onSetlist(setlist);
        this.setState({ setlistModalOpen: false });
    };

    _getCustomFields = () => {
        const { categoryConfig } = this.props;
        if (!categoryConfig || !categoryConfig.categories) {
            return [];
        }
        return categoryConfig.categories;
    };

    _isCategoryVisible = (category, partnerId) => {
        return category.visibleByDefault || category.visibleByPartners.includes(partnerId);
    };

    _getLabelDisplayValue = (partnerClearing, category) => {
        const clearingValue = partnerClearing[category.id];
        const label = category.labels.find(label => label?.id === clearingValue?.labelId);
        return {
            label: label?.label || '',
            color: label?.color || null,
            untilDate: clearingValue?.untilDate || null
        };
    };
    render() {
        const customFields = this._getCustomFields();
        const clearing = this.props.clearing || [];
        const widthFromLength = length => Math.max(200, length * 9 + 40);

        let partnerMaxLength = 'Mediapartner'.length;
        clearing.forEach(partnerClearing => {
            const partnerName = this._getPartnerName(partnerClearing) || '';
            if (partnerName.length > partnerMaxLength) {
                partnerMaxLength = partnerName.length;
            }
        });
        const partnerColWidth = widthFromLength(partnerMaxLength);

        // TODO: clean this up
        const categoryColWidths = {};
        customFields.forEach(category => {
            let maxLength = (category.label || '').length;
            clearing.forEach(partnerClearing => {
                if (!this._isCategoryVisible(category, partnerClearing.partnerId)) {
                    return;
                }
                const { label, untilDate } = this._getLabelDisplayValue(partnerClearing, category);
                if ((label || '').length > maxLength) {
                    maxLength = (label || '').length;
                    if (untilDate && !isUnlimited(untilDate)) {
                        maxLength += 15;
                    }
                }
            });
            categoryColWidths[category.id] = widthFromLength(maxLength);
        });

        let commentMaxLength = 'Comment'.length;
        clearing.forEach(partnerClearing => {
            const comment = partnerClearing.comment || '';
            if (comment.length > commentMaxLength) {
                commentMaxLength = comment.length;
            }
        });
        const commentColWidth = widthFromLength(commentMaxLength);

        const totalWidth =
            partnerColWidth +
            commentColWidth +
            customFields.reduce((sum, category) => sum + (categoryColWidths[category.id] || 0), 0) +
            (customFields.length + 2) * 20 +
            40;

        return (
            <div>
                <header className="ckp-admin-performances-form-title">
                    <h4 className="ckp-ts-h1">Clearance</h4>
                    <UserContext.Consumer>
                        {user => (
                            <div className="ckp-admin-performances-form-contracts">
                                <Button onClick={this._openSetlistModal} label="Edit Setlist" />
                                {accessToClearance(user, this.props.organizationId) && this.props.performanceId ? (
                                    <Button
                                        onClick={this.props.openContractModal}
                                        label={'Create Clearance contract'}
                                    />
                                ) : null}
                                {/* REMOVED DUE TO CATEGORIES REWORK (EW-116)
                                {accessToClearance(user, this.props.organizationId) && this.props.contractToLoad ? (
                                    <Button
                                        onClick={this.props.loadContractInfo}
                                        label={'Import from contract'}
                                        inactive={!this.props.contractToLoad}
                                        loading={this.props.fetchingContracts}
                                    />
                                ) : null}
                                 */}
                            </div>
                        )}
                    </UserContext.Consumer>
                </header>
                <PerformancesModal
                    getPartnerName={this._getPartnerName}
                    open={this.state.editModalOpen}
                    closeModal={this._closeModal}
                    saveModal={this._saveModal}
                    dependencies={this.props.dependencies}
                    categories={customFields.filter(category =>
                        this._isCategoryVisible(category, this.state.editModalOpen.partnerId)
                    )}
                />
                <PerformancesSetlistModal
                    open={this.state.setlistModalOpen}
                    setlist={this.props.setlist}
                    closeModal={this._closeSetlistModal}
                    saveModal={this._saveSetlistModal}
                />
                <div className="ckp-admin-table-dark">
                    <ul className="ckp-admin-table-dark-header" style={{ minWidth: `${totalWidth}px` }}>
                        <li
                            className="ckp-admin-table-dark-header-title"
                            style={{
                                width: `${partnerColWidth}px`,
                                minWidth: `${partnerColWidth}px`,
                                flex: `0 0 ${partnerColWidth}px`
                            }}
                        >
                            Mediapartner
                        </li>
                        {customFields.map(category => (
                            <li
                                key={category.id}
                                className="ckp-admin-table-dark-header-title"
                                style={{
                                    width: `${categoryColWidths[category.id]}px`,
                                    minWidth: `${categoryColWidths[category.id]}px`,
                                    flex: `0 0 ${categoryColWidths[category.id]}px`
                                }}
                            >
                                {category.label}
                            </li>
                        ))}
                        <li
                            className="ckp-admin-table-dark-header-title"
                            style={{
                                width: `${commentColWidth}px`,
                                minWidth: `${commentColWidth}px`,
                                flex: `0 0 ${commentColWidth}px`
                            }}
                        >
                            Comment
                        </li>
                    </ul>
                    <div className="ckp-admin-table-dark-body">
                        {clearing.map(partnerClearing => {
                            return (
                                <ul
                                    onClick={() => this._openModal(partnerClearing)}
                                    key={partnerClearing.partnerId}
                                    className="ckp-admin-table-dark-row"
                                    style={{ cursor: 'pointer', minWidth: `${totalWidth}px` }}
                                >
                                    <li
                                        className="ckp-admin-table-dark-column u-truncate"
                                        style={{
                                            width: `${partnerColWidth}px`,
                                            minWidth: `${partnerColWidth}px`,
                                            flex: `0 0 ${partnerColWidth}px`
                                        }}
                                    >
                                        {this._getPartnerName(partnerClearing)}
                                    </li>
                                    {customFields.map(category => {
                                        const { label, color, untilDate } = this._getLabelDisplayValue(
                                            partnerClearing,
                                            category
                                        );

                                        if (!this._isCategoryVisible(category, partnerClearing.partnerId)) {
                                            return (
                                                <li
                                                    key={`${category.id}-${partnerClearing.partnerId}`}
                                                    className="ckp-admin-table-dark-column u-truncate"
                                                    style={{
                                                        width: `${categoryColWidths[category.id]}px`,
                                                        minWidth: `${categoryColWidths[category.id]}px`,
                                                        flex: `0 0 ${categoryColWidths[category.id]}px`
                                                    }}
                                                >
                                                    <Tooltip title="Category is not visible for this partner.">
                                                        <span className="ckp-admin-clearance-na">N/A</span>
                                                    </Tooltip>
                                                </li>
                                            );
                                        }

                                        return (
                                            <li
                                                key={`${category.id}-${partnerClearing.partnerId}`}
                                                className="ckp-admin-table-dark-column u-truncate"
                                                style={{
                                                    width: `${categoryColWidths[category.id]}px`,
                                                    minWidth: `${categoryColWidths[category.id]}px`,
                                                    flex: `0 0 ${categoryColWidths[category.id]}px`
                                                }}
                                            >
                                                <CategoryBadge
                                                    key={`${category.id}-${partnerClearing.partnerId}`}
                                                    label={label}
                                                    color={color}
                                                    untilDate={untilDate}
                                                    showHidden={true}
                                                />
                                            </li>
                                        );
                                    })}
                                    <li
                                        className="ckp-admin-table-dark-column u-truncate"
                                        style={{
                                            width: `${commentColWidth}px`,
                                            minWidth: `${commentColWidth}px`,
                                            flex: `0 0 ${commentColWidth}px`
                                        }}
                                    >
                                        {partnerClearing.comment || ''}
                                    </li>
                                </ul>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    }
}

export default PerformancesStates;
